"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _selectors = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _classnames3 = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactDeviceDetect = require("react-device-detect");
var _pluralTranslations = require("../../../../localization/pluralTranslations");
var _Divider = require("../../../ui/Divider");
var _styles = _interopRequireDefault(require("../../styles.scss"));
var _DropdownBody = _interopRequireDefault(require("./components/DropdownBody"));
var _actions = require("./store/actions");
var _selectors2 = require("./store/selectors");
var _helpers2 = require("./helpers");
var _styles2 = _interopRequireDefault(require("./styles"));
var _arrow = _interopRequireDefault(require("./arrow.svg"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var getPrimaryBackgroundColorProxy = function getPrimaryBackgroundColorProxy(_ref) {
  var isOpen = _ref.isOpen,
    theme = _ref.theme;
  if (_reactDeviceDetect.isMobileOnly && isOpen) {
    return (0, _helpers2.getPrimaryBackgroundColor)(theme);
  }
  return undefined;
};
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n :before {\n  background-color: ", "\n }\n"])), getPrimaryBackgroundColorProxy);
var ResultDropdownButton = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", "\n"])), function (_ref2) {
  var isOpen = _ref2.isOpen,
    theme = _ref2.theme;
  return _reactDeviceDetect.isDesktop && isOpen ? (0, _helpers2.getPrimaryBackgroundColor)(theme) : undefined;
});
var PricesMatrixDropdown = function PricesMatrixDropdown(_ref3) {
  var compact = _ref3.compact,
    country = _ref3.country,
    currency = _ref3.currency,
    hotelID = _ref3.hotelID,
    offer = _ref3.offer,
    queriesIDs = _ref3.queriesIDs;
  var isSearchBySingleHotel = (0, _reactRedux.useSelector)(_selectors2.getIsSearchBySingleHotel);
  var _useState = (0, _react.useState)(isSearchBySingleHotel),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  var operatorsTranslation = (0, _pluralTranslations.usePluralOperatorsTranslation)();
  var operatorsSufixAccusativeTranslation = (0, _pluralTranslations.usePluralOperatorsSufixAccusativeTranslation)();
  var getOperatorsCountByHotelID = (0, _react.useMemo)(function () {
    return (0, _selectors2.createGetOperatorsCountByHotelID)((0, _helpers.generateOperatorKey)(country.id, offer.departure), hotelID);
  }, [country.id, hotelID, offer.departure]);
  var operatorsCountByHotelID = (0, _reactRedux.useSelector)(getOperatorsCountByHotelID);
  var operatorSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getOperator)(), [{
      operatorID: offer.operator,
      key: (0, _helpers.generateOperatorKey)(country.id, offer.departure)
    }]);
  }, [country.id, offer.departure, offer.operator]);
  var operatorByRootOffer = (0, _reactRedux.useSelector)(operatorSelector);
  var handleOpen = function handleOpen() {
    if (!isSearchBySingleHotel) {
      dispatch((0, _actions.getPricesByHotel)(hotelID, queriesIDs));
    }
    setIsOpen(true);
  };
  var handleClose = function handleClose() {
    if (!isSearchBySingleHotel) {
      dispatch((0, _actions.removePricesByHotel)(queriesIDs));
    }
    setIsOpen(false);
  };
  (0, _react.useEffect)(function () {
    return function () {
      if (!isSearchBySingleHotel) {
        dispatch((0, _actions.removePricesByHotel)(queriesIDs));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, {
    className: (0, _classnames3.default)(_styles2.default.resultDropdownContainer, _defineProperty({}, _styles2.default['resultDropdownContainer--opened'], isOpen)),
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(ResultDropdownButton, {
    className: (0, _classnames3.default)(_styles2.default.resultDropdownButton, _defineProperty(_defineProperty({}, _styles2.default.active, isOpen), _styles2.default.compactButton, compact)),
    isOpen: isOpen,
    onClick: isOpen ? handleClose : handleOpen
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles2.default.resultDropdownButtonText
  }, compact ? operatorsCountByHotelID >= 2 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, operatorByRootOffer.name, ' ', "+ ".concat(operatorsCountByHotelID - 1, " ").concat(operatorsTranslation(operatorsCountByHotelID - 1))) : operatorByRootOffer.name : operatorsCountByHotelID > 1 ? R.concat("".concat(t('PRICE_MATRIX_BUTTON_TOGGLER'), " "), operatorsSufixAccusativeTranslation(operatorsCountByHotelID, {
    operatorsCount: operatorsCountByHotelID
  })) : t('PRICE_MATRIX_BUTTON_TOGGLER')), /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.icon,
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    }
  })), isOpen && /*#__PURE__*/_react.default.createElement(_DropdownBody.default, {
    compact: compact,
    country: country,
    currency: currency,
    hotelID: hotelID,
    queriesIDs: queriesIDs
  })), _reactDeviceDetect.isMobileOnly && isOpen && /*#__PURE__*/_react.default.createElement(_Divider.Divider, {
    className: _styles2.default.divider
  }));
};
PricesMatrixDropdown.propTypes = {
  country: _propTypes.default.shape({
    id: _propTypes.default.number.isRequired
  }).isRequired,
  currency: _propTypes.default.object.isRequired,
  hotelID: _propTypes.default.number.isRequired,
  offer: _propTypes.default.object.isRequired,
  queriesIDs: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  compact: _propTypes.default.bool
};
var _default = exports.default = (0, _react.memo)(PricesMatrixDropdown);